var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"value":_vm.value,"rotate":-90,"color":"face-match"}},[(_vm.text)?_c('span',[_vm._v(" "+_vm._s(_vm.value))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }